<template>
	<div class="bg2">
		<!-- <Header title="我的订单" background="#FFFFFF"></Header> -->
		<van-tabs v-model="form.condition.status" :swipe-threshold="2" @change="tabsChange">
			<van-tab :title="item.name" v-for="(item, index) in tabs" :name="item.id" :key="index">
			</van-tab>
		</van-tabs>
		<div class="lists">
			<van-list v-model="loading" :finished="finished" finished-text="" loading-text="" @load="selectOrder">
				<div v-for="item,index in list" class="list" :key="index">
					<div class="listTop flex-between" @click="goUrl('/my/orderDetial?id=',item.id)">
						<span>订单编号：{{item.orderNo}}</span>
						<span class="status" v-if="item.status==1">待出库</span>
						<span class="status" v-if="item.status==2">待出库</span>
						<span class="status" v-if="item.status==3">待支付</span>
						<span class="status" v-if="item.status==4">待发货</span>
						<span class="status" v-if="item.status==5">待收货</span>
						<span class="status" v-if="item.status==6">已收货</span>
						<span class="status" v-if="item.status==8">已出库</span>
						<span class="status" v-if="item.status==-1">申请退款中</span>
						<span class="status" v-if="item.status==-2">下单失败待退款</span>
						<span class="status" v-if="item.status==-100&&item.refundAt">已退款</span>
						<span class="status" v-if="item.status==-100&&!item.refundAt">订单取消</span>
					</div>
					<div class="listCenter" v-for="e,index in item.goodsList" :key="index" @click="goDetailUrl(e.goodsId)">
						<img :src="e.goodsThumb" alt="" />
						<div class="goods flex-between">
							<div class="goodsName">{{e.goodsTitle}}</div>
							<div class="goodsNum">
								<p>￥{{e.price}}</p>
								<p>x {{e.num}}</p>
							</div>
						</div>
					</div>
					<div class="bottom">
						<div class="freight" v-if="item.status == 3">{{active == 3 ? "国际运费" : "运费"}}：{{item.freight}}</div>
						<div class="price" v-if="active != 3">
							<span> 共{{item.goodsList.length}}件商品，合计 </span>
							<span> ￥{{parseFloat(item.price) + parseFloat(item.freight)}} </span>
						</div>
						<div class="btns">
							<!-- <span v-if="item.status==1||item.status==2||item.status==8" @click.stop="showClose(item.id)">取消订单</span> -->
							<span class="status" v-if="item.status==0" @click.stop="payOrder(item.id)">立即支付</span>
							<span class="status" v-if="item.status==3" @click.stop="playPay(item.id)">支付运费</span>
							<span v-if="item.status==4||item.status==5"
								@click.stop="goUrl('/my/tuiDetails?id=',item,1)">申请退款</span>
							<span v-if="item.status==5" @click.stop="goUrl('/my/wuliu?id=',item,1)">查看物流</span>
							<span class="status" v-if="item.status==5" @click.stop="confirmGoods(item.id)">确认收货</span>
						</div>
					</div>
				</div>
			</van-list>

		</div>
		<van-action-sheet title="取消订单原因" v-model="showCloseOrder" :actions="closeOrderList" cancel-text="取消"
			close-on-click-action @select="closeOrder" />
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				showCloseOrder: false,
				active: 0,
				scrollTop: 0,
				tabs: [{
						name: "全部",
						id: -1,
					},
					{
						name: "待支付",
						id: 0,
					},
					{
						name: "出库",
						id: 12,
					},
					{
						name: "待支付运费",
						id: 3,
					},
					{
						name: "待收货",
						id: 45,
					},
					{
						name: "完成",
						id: 6,
					},
					{
						name: "取消/退款",
						id: -112,
					},
				],
				closeOrderList: [{
						name: '商品与描述不符'
					},
					{
						name: '发错商品'
					},
					{
						name: '其他'
					},
				],
				list: [],
				form: {
					lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
					page: 1, // 必选 请求数据页码
					condition: {
						status: '', // 商品分类ID。若不指定分类则传0
					}, // 必选 搜索条件
				},
				loading: false,
				finished: false,
				id: undefined,
			};
		},
		computed: {

		},
		watch: {
			"form.condition.status"(val) {
				this.form.page = 1
				this.form.lastId = 0
				// this.selectOrder()
			}
		},
		mounted() {
			// this.selectOrder()
		},
		beforeRouteLeave(to, from, next) {
			// console.log(document.documentElement.scrollTop,document.body.scrollTop,window.pageYOffset,222)
			from.meta.keepAlive = true;

			this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
			// 设置下一个路由的 meta
			next();
		},
		beforeRouteEnter(to,from,next){
			to.meta.keepAlive = true;

			next(vm =>{
				// console.log("hhhhhhhhh", vm.scrollTop)
				document.body.scrollTop = vm.scrollTop;
			})  
		},
		methods: {
			// goUrl(id){
			//   this.$router.push('/my/orderDetial?id='+id)
			// },
			// 确认收货
			confirmGoods(id) {
				let _this = this
				this.$dialog.confirm({
						title: '确认收货',
						message: '是否确认收货',
					})
					.then(() => {
						let ids = Array();
						this.$post({
							url: "/portal/Shop",
							module: "Order",
							interface: "3003",
							data: {
								id: id
							},
						}).then((res) => {
							this.$toast('确认成功')
							this.form.page = 1;
							this.selectOrder()
						})
					})
					.catch(() => {
						// on cancel
					});
			},
			// tabs切换  重置数据
			tabsChange(value) {
				this.active = value;
				console.log(value,"value",this.active);
				this.loading = true;
				this.finished = false;
				this.form.lastId = 0;
				this.form.page = 1;
				this.list = [];
				this.selectOrder();
			},
			goUrl(path, item, type) {
				if (type) {
					this.$router.push(path + JSON.stringify(item))
				} else {
					this.$router.push(path + item)
				}

			},
			goDetailUrl(code) {
				this.goUrl('/classify/commodity/details/', code);
			},
			showClose(id) {
				this.id = id;
				this.showCloseOrder = true;
			},
			payOrder(id) {
				let ids = Array();
				ids.push(id)
				this.$post({
					url: "/portal/Shop",
					module: "Order",
					interface: "1102",
					data: {
						ids: ids,
						payType: "220",
					},
				})
				.then((res) => {
					let sign = JSON.parse(res.charge);
					// console.log(sign,333)
					let _this = this;
					// eslint-disable-next-line no-undef
					WeixinJSBridge.invoke(
						"getBrandWCPayRequest", {
							appId: sign.appId, //公众号名称，由商户传入
							timeStamp: sign.timeStamp.toString(), //时间戳，自1970年以来的秒数
							nonceStr: sign.nonceStr, //随机串
							package: sign.package,
							signType: "MD5", //微信签名方式：
							paySign: sign.paySign, //微信签名
						},
						function(res) {
							if (res.err_msg == "get_brand_wcpay_request:ok") {
								_this.$toast('支付成功')
								_this.form.page = 1;
								_this.selectOrder()
							} else {
								_this.$toast('支付失败，请稍后再试')
							}
						}
					);
				})
				.catch((error) => {
					console.log(error);
				});
			},
			playPay(id) {
				let ids = Array();
				ids.push(id)
				this.$post({
						url: "/portal/Shop",
						module: "Order",
						interface: "1104",
						data: {
							ids: ids,
							payType: '220'
						},
					})
					// .then((res) => {
					// 	this.$toast('支付成功')
					// 	this.form.page=1;
					// 	this.selectOrder()
					// })
					.then((res) => {
						let sign = JSON.parse(res.charge)
						// console.log(sign,333)
						let _this = this;
						WeixinJSBridge.invoke(
							'getBrandWCPayRequest', {
								"appId": sign.appId, //公众号名称，由商户传入     
								"timeStamp": sign.timeStamp.toString(), //时间戳，自1970年以来的秒数     
								"nonceStr": sign.nonceStr, //随机串     
								"package": sign.package,
								"signType": "MD5", //微信签名方式：     
								"paySign": sign.paySign //微信签名 
							},
							function(res) {
								if (res.err_msg == "get_brand_wcpay_request:ok") {
									// _this.$toast('支付成功')
									// _this.buySuccess(ids)
									_this.$toast('支付成功')
									_this.form.page = 1;
									_this.selectOrder()
								} else {
									_this.$toast('支付失败，请稍后再试')
								}
							}
						);

					})
					.catch((error) => {
						console.log(error);
						// this.$router.replace({
						//   name: "classifyCommoditysuccess",
						//   params: {
						//     payMoney: this.info.goodsPrice,
						//     success: false,
						//   },
						// });
					});
			},
			//取消订单
			closeOrder(e) {
				this.$post({
					url: "/portal/Shop",
					module: "Order",
					interface: "3000",
					data: {
						id: this.id,
						reason: e.name
					},
				}).then((res) => {
					this.form.page = 1;
					this.selectOrder()
				})

			},
			// 查询订单
			selectOrder() {
				this.$post({
					url: "/portal/Shop",
					module: "Order",
					interface: "2001",
					data: this.form,
				}).then((res) => {
					console.log(res,"订单列表");
					// if (this.page = 1) {
					// 	this.list = []
					// 	this.form.lastId = 0
					// }
					this.form.lastId = res.lastId;
					this.form.page++;
					this.finished = res.currentPage >= res.lastPage;
					this.list = this.list.concat(res.list);
					this.loading = false;
				});
			}
		},
	};
</script>

<style lang='less' scoped>
	.lists {
		margin: 14px 16px;

		.list {
			background: #ffffff;
			box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			padding: 0 14px;
			margin-bottom: 15px;

			.listTop {
				height: 50px;
				font-size: 12px;

				.status {
					color: #fd0212;
				}
			}

			.listCenter {
				display: flex;
				align-items: flex-start;
				border-bottom: 1px solid #f0f0f0;

				img {
					width: 88px;
					height: 88px;
				}

				.goods {
					flex: 1;

					.goodsName {
						font-size: 15px;
					}

					.goodsNum {
						font-size: 13px;

						p:nth-child(2) {
							color: #919398;
						}
					}
				}
			}

			.bottom {
				.freight {
					color: #333333;
					font-size: 13px;
					display: flex;
					justify-content: flex-end;
				}
				.price {
					display: flex;
					justify-content: flex-end;
					align-items: center;
					font-size: 13px;
					color: #606266;
					height: 30px;

					span:nth-child(2) {
						color: #101010;
					}
				}

				.btns {
					height: 40px;
					display: flex;
					justify-content: flex-end;
					align-items: center;

					span {
						width: 68px;
						height: 26px;
						background: #ffffff;
						border-radius: 13px;
						border: 1px solid #fd0212;
						color: #fd0212;
						text-align: center;
						line-height: 26px;
						font-size: 12px;
						margin-left: 12px;
					}

					.status {
						background: #fd0212;
						color: #ffffff;
					}
				}
			}
		}
	}
</style>
